<template>
    <div class="container">
        <Header/>

        <div class="challenge_content">
            <div class="section_name">{{sectionName}}</div>
            <div class="content_nav">
                <div class="topic" v-if="step == 1">
                    <div class="title">
                        <span v-if="TopicData && TopicData.length">
                            <span class="tipic_num">{{ currIndex + 1 }}</span>
                            <span class="tipic_desc">{{TopicData.length && TopicData[currIndex].examTypeDesc}}</span>
							<span style="color:red;" v-if="false">&nbsp;&nbsp;注意：如发现该题有误，可点击“本题有误”按钮，该操作将被记录！
<!--							<span style="color:red;"  v-if="skipFNFlag && skipData[currIndex] == 0">&nbsp;&nbsp;注意：如发现该题有误，可点击“本题有误”按钮，该操作将被记录！-->
								<el-button class="next_btn skip_challenge" @click="skipTopic">本题有误</el-button>
							</span>
							<span style="color:red;padding-left: 20px;" v-if="skipData[currIndex] == 1">试题已跳过，该题无需作答！</span>
<!--							<span style="color:red;" v-if="skipData[currIndex] == 1">&nbsp;&nbsp;注意：该题有误时，可点击右侧“跳过本题”按钮，该操作将被记录！-->
<!--								<el-button class="next_btn skip_challenge" @click="againTopic">{{"重新做题"}}</el-button>-->
<!--							</span>-->
<!--							<span v-if="TopicData[currIndex].examType==3 && currIndex != 5" style="color:red;">&nbsp;&nbsp;注意：请点击”下一题“按钮完成填空题答案保存！</span>-->
						</span>
                        <span v-else></span>
                    </div>
                    <div class="topic_content" :class="skipData[currIndex] == 1?'skip_content':''" v-if="TopicData && TopicData.length">
                        <div class="content_html" :id="'content_'+currIndex" v-html="TopicData[currIndex].content">
                        </div>
                        <!--单选-->
                        <div class="topic_option" v-if="TopicData[currIndex].examType == 1">
                            <el-radio-group v-model="paramsItem[('val'+currIndex)]" @change="clickOption">
                                <div v-for="(item, index) in TopicData[currIndex].info" :key="index">
                                    <div class="option_item">
                                        <el-radio border :label="item.id" :value="item.id">
                                            <span class="space">{{ index | computedNum }}</span>
                                            <div class="item_content" v-html="item.content"></div>
                                        </el-radio>
                                    </div>
                                </div>
                            </el-radio-group>
                        </div>
                        <!--多选-->
                        <div class="topic_option" v-if="TopicData[currIndex].examType == 2">
                            <el-checkbox-group v-model="paramsItem[('val'+currIndex)]" @change="clickOption">
                                <div v-for="(item, index) in TopicData[currIndex].info" :key="index">
                                    <div class="option_item">
                                        <el-checkbox border :label="item.id" :value="item.id">
                                            <span class="space">{{ index | computedNum }}</span>
                                            <div class="item_content" v-html="item.content"></div>
                                        </el-checkbox>
                                    </div>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <!--判断-->
                        <div class="topic_option" v-if="TopicData[currIndex].examType == 4">
                            <el-radio-group v-model="paramsItem[('val'+currIndex)]" @change="clickOption">
                                <!-- <div v-for="(item, index) in judgeData" :key="index"> -->
                                <div class="option_item">
                                    <el-radio border :label="1" :value="1">
                                        <div class="judge_item">正确</div>
                                    </el-radio>
                                </div>
                                <div class="option_item">
                                    <el-radio border :label="0" :value="0">
                                        <div class="judge_item">错误</div>
                                    </el-radio>
                                </div>
                                <!-- </div> -->
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="next" v-if="TopicData && TopicData.length > 1 && currIndex + 1 !== TopicData.length">
<!--                        :class="isDisabled ? 'isdisabled' : ''"-->
<!--                        :disabled="isDisabled"-->
                        <el-button
                                class="next_btn"

                                @click="nextTopic"
                        >{{
                            "下一题"
                            }}
                        </el-button
                        >
                    </div>
                </div>
                <div class="topic_step2" id="topic_step2" v-if="step == 2">
                    <div class="aaa" :class="item.isSkip && item.isSkip==1?'skip_content':''" :id="'topic'+ index" v-for="(item, index) in topicDetail" :key="index">
                        <div class="title">
                            <span v-if="TopicData && TopicData.length">
                                <span class="tipic_num">{{ index + 1 }}</span>
                                <span class="tipic_desc">{{item.examTypeDesc}}</span>
<!--                                <span class="tipic_desc">{{TopicData.length && TopicData[currIndex].examTypeDesc}}</span>-->
                                <span v-if="item.isSkip && item.isSkip==1" style="color:red;padding-left: 20px;">试题已跳过，该题未记录作答！</span>
                            </span>
                            <span v-else></span>
                        </div>
                        <div class="topic_content" :ref="'st1_'+item.id">
                            <div class="topic_title">
                                <div class="content_html" v-html="item.content"></div>
                                <!--                                <span :class="item.isRight ? 'right' : 'error'">{{ item.isRight ? "√" : "×"
                                }}</span>-->
                            </div>
                            <div class="topic_option" v-if="item.examType == 1">
                                <div v-for="(item2, i) in item.info" :key="i">
                                    <div class="select_option"
                                         :class=" item2.userSelectFlag ? 'select_active' : ''">
                                        <span class="num">{{ i | computedNum }}.</span>
                                        <span class="select_content">
                                            <span v-html="item2.content"></span>
                                            <img class="type1AndType2Img"
                                                 v-if="item2.optionRightFlag"
                                                 src="../../src/assets/images/right_icon.png">
                                            <img class="type1AndType2Img"
                                                 v-if="item2.userSelectFlag && !item2.optionRightFlag"
                                                 src="../../src/assets/images/error_icon.png">
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="topic_option" v-if="item.examType == 2">
                                <div v-for="(item2, i) in item.info" :key="i">
                                    <div class="select_option"
                                         :class="item2.userSelectFlag ? 'select_active' : ''">
                                        <span class="num">{{ i | computedNum }}</span>
                                        <span class="select_content">
                                            <span v-html="item2.content"></span>
                                            <img class="type1AndType2Img"
                                                 v-if="item2.optionRightFlag"
                                                 src="../../src/assets/images/right_icon.png">
                                            <img class="type1AndType2Img"
                                                 v-if="item2.userSelectFlag && !item2.optionRightFlag"
                                                 src="../../src/assets/images/error_icon.png">
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="topic_option" v-if="item.examType == 4">
                                <div v-for="(item2, i) in item.info" :key="i">
                                    <div class="select_option"
                                         :class="item2.userAnswer === '0' ? 'select_active' : ''">
                                        <span class="select_content">
                                            <span>错误</span>
                                            <img class="type4Img"
                                                 v-if="item2.rightAnswer === '0'"
                                                 src="../../src/assets/images/right_icon.png">
                                            <img class="type4Img"
                                                 v-if="item2.userAnswer === '0' && item2.rightAnswer !== '0'"
                                                 src="../../src/assets/images/error_icon.png">
                                        </span>
                                    </div>
                                    <div class="select_option"
                                         :class="item2.userAnswer === '1' ? 'select_active' : ''">
                                         <span class="select_content">
                                             <span>正确</span>
                                             <img class="type4Img"
                                                  v-if="item2.rightAnswer === '1'"
                                                  src="../../src/assets/images/right_icon.png">
                                             <img class="type4Img"
                                                  v-if="item2.userAnswer === '1' && item2.rightAnswer !== '1'"
                                                  src="../../src/assets/images/error_icon.png">
                                         </span>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(item2, i) in item.info" :key="i">
                                <div class="answer_div" v-if="item.examType == 3 && !item.isRight">
                                    <span>正确答案：</span>
                                    <span v-for="(userA, z) in item2.rightAnswer" :key="z">
                                        <span class="answer">{{ userA }}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="content_bottom">
                            <fieldset class="fieldset">
                                <legend class="legend">知识点</legend>
                                <div class="zhishidian" v-for="(kitem,i) in item.knowledges" :key="i">
                                    <div class="item" @click="openVideo('knowledge', kitem)">
                                        {{kitem.name}}
                                    </div>
                                </div>
                                <div class="no_data zhishidian" v-if="item.knowledges && !item.knowledges.length">
                                    暂无
                                </div>
                                <div class="knowledge">
									<div v-if="!item.analysis || !item.analysis.video || item.analysis.video.length<1 || !item.analysis.video[0].videoUrl"
										 @click="openExamAnalysis(item.examAnalysis,item.analysis)" class="knowledge_content">
										<span><i class="iconfont">&#xe626;</i>习题讲解</span>
									</div>
                                    <div v-if="item.analysis && item.analysis.video && item.analysis.video.length>0 && !!item.analysis.video[0].videoUrl" class="knowledge_content"
                                         @click="openVideo( 'similar', item.analysis ? item.analysis : '', item.examAnalysis)">
                                        <span>
                                            <i class="iconfont">&#xe603;</i>
                                            类似题讲解
                                        </span>
                                    </div>
									<div @click="openAIAnalysis(item.id)" class="knowledge_content">
										<span><i class="iconfont">&#xe626;</i>AI解析</span>
									</div>
                                    <el-dialog
                                            :visible.sync="problemsPopover"
                                            top="35vh"
                                            width="500px"
                                            custom-class="EscModal"
                                            @closed="problemDialogClosed"
                                            :key="item.id"
											title="报告问题"
                                    >
                                        <div :id="'pop'+index" style="height:155px;">
											<el-checkbox-group v-model="textarea" style="margin-left:80px;width: 65%;">
												<el-checkbox value="答案一致，批改错误" label="答案一致，批改错误" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">答案一致，批改错误</span>
												</el-checkbox>
												<el-checkbox value="参考答案不正确" label="参考答案不正确" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">参考答案不正确</span>
												</el-checkbox>
												<el-checkbox value="视频解析不对应" label="视频解析不对应" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">视频解析不对应</span>
												</el-checkbox>
												<el-checkbox value="解析不正确" label="解析不正确" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">解析不正确</span>
												</el-checkbox>
												<el-input v-model="inputTextarea" placeholder="有其他问题？请在此处填写"
														  style="font-size:20px;line-height:30px;float:left;margin-bottom:5px;"></el-input>
											</el-checkbox-group>
                                            <div style="text-align: right; float:right; margin: 0">
                                                <el-button size="mini" type="text" @click="problemsPopover = false">取消
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="reportProblem(item.id)">
                                                    确定
                                                </el-button>
                                            </div>
                                        </div>
                                    </el-dialog>
									<el-dialog
										title="解题思路"
										:visible.sync="examAnalysisDialogVisible"
										width="580px"
										:before-close="handleClose"
									>
										<div style="text-align:left;">
											<div v-html="examAnalysis"></div>
											<div class="no_videoUrl" v-if="!examAnalysis">
												<span>暂无习题讲解</span>
											</div>
										</div>
										<span slot="footer" class="dialog-footer"></span>
									</el-dialog>
									<!-- AI解析弹窗 -->
									<el-dialog
										:visible.sync="AIAnalysisDialogVisible"
										width="70%"
										top="10vh"
										title="AI大模型解析"
										:before-close="handleClose"
									>
										<div class="modal-header">
											<span class="title">基于 Doubao-Seed-2-0-Lite</span>
											<span class="subtitle" style="color:red!important;">注:AI解析内容仅供参考，特别是理科类含图片、公式的题型</span>
										</div>
										<!-- 试题原文 -->
										<div
											class="topic_content diy-topic-title"
											style="border: dashed 1px gray; border-radius: 17px;transform: scale(0.9); transform-origin: left top; margin: 15px 0;"
											v-html="stContent1"
										></div>
										<!-- 修正后：解析中且未处理完成时，始终显示 Loading -->
										<LoadingAnimation :is-loading="aiExamAnalysis == ''" />
										<!-- 错误提示 -->
										<div class="error-tip" v-if="analysisError">{{ analysisError }}</div>
										<!-- 解析内容容器（带滚动） -->
										<div
											class="analysis-content"
											v-html="aiExamAnalysis"
											ref="analysisContent"
										></div>
									</el-dialog>
                                    <el-button class="intelligent_tutoring"
                                               style="pointer-events: auto;color:#666;" type="text"
                                               @click="onImproveProblems(item)"><i class="iconfont" style="color:#666;">&#xe601;</i>
                                    </el-button>
                                    <!--                                    <el-popover-->
                                    <!--                                            placement="top"-->
                                    <!--                                            title="我要纠错"-->
                                    <!--                                            width="200"-->
                                    <!--                                            v-model="problemsPopover">-->
                                    <!--                                        <div :id="'pop'+index">-->
                                    <!--                                            <p>-->
                                    <!--                                                <el-input-->
                                    <!--                                                        type="textarea"-->
                                    <!--                                                        :rows="3"-->
                                    <!--                                                        placeholder="请输入您发现的问题"-->
                                    <!--                                                        v-model="textarea">-->
                                    <!--                                                </el-input>-->
                                    <!--                                            </p>-->
                                    <!--                                            <div style="text-align: right; margin: 0">-->
                                    <!--                                                <el-button size="mini" type="text" @click="problemsPopover = false">取消-->
                                    <!--                                                </el-button>-->
                                    <!--                                                <el-button type="primary" size="mini" @click="reportProblem(item.id)">-->
                                    <!--                                                    确定-->
                                    <!--                                                </el-button>-->
                                    <!--                                            </div>-->
                                    <!--                                        </div>-->
                                    <!--                                        &lt;!&ndash; <el-button slot="reference">click 激活</el-button> &ndash;&gt;-->
                                    <!--                                        <el-button slot="reference" class="intelligent_tutoring"-->
                                    <!--                                                   style="pointer-events: auto;" type="text"><i class="iconfont">&#xe601;</i>我要纠错-->
                                    <!--                                        </el-button>-->
                                    <!--                                        &lt;!&ndash; <div slot="reference" class="intelligent_tutoring">-->
                                    <!--                                          <i class="iconfont">&#xe601;</i>-->
                                    <!--                                          报告问题-->
                                    <!--                                        </div> &ndash;&gt;-->
                                    <!--                                    </el-popover>-->

                                </div>
                            </fieldset>
                        </div>

                    </div>
                </div>

                <div v-if="step === 1" class="Subject_right">
                    <div class="Popup">
                        <span @click="centerDialogVisible = true">结束练习</span>
                        <el-dialog
                                v-if="step === 1"
                                :visible.sync="centerDialogVisible"
                                :modal="false"
                                top="35vh"
                                width="432px"
                                custom-class="EscModal"
                        >
                            <div class="Tips">
                                <div class="top">
                                    <p class="p1"><span class="warning">!</span> 退出训练则成绩无效</p>
                                    <p class="p2">答完所有题目，确认交卷后才会获得评测结果</p>
                                </div>
                                <div class="btn_div">
                                    <div class="btn1">
                                        <el-button type="primary btn" @click="centerDialogVisible = false">继续训练
                                        </el-button>
                                        <el-button type="primary btn" @click="signOut">退出训练</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                        <el-dialog
                                v-if="step === 2"
                                :visible.sync="centerDialogVisible"
                                :modal="false"
                                top="35vh"
                                width="432px"
                                custom-class="EscModal"
                        >
                            <div class="Tips">
                                <div class="top">
                                    <p class="p1">历史最高成绩</p>
                                    <div class="center">
                                        <img class="img" :src="basicsData.highestLevelImgUrl">
                                    </div>
                                </div>
                                <div class="btn_div">
                                    <div class="btn1">
                                        <el-button type="primary btn" @click="onceAgain">继续训练
                                        </el-button>
                                        <el-button type="primary btn" @click="signOut">退出训练</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                    </div>
                    <div class="times">
                        <div class="title_name">答题时间</div>
                        <div class="title_time">
                            <div ref="startTimer">{{basicsData.totalLongOfTime}}</div>
                        </div>
                    </div>
                    <!-- 点击显示隐藏部分 -->
                    <!-- 点击提交前的样式 -->
                    <div class="hides" v-if="step == 1">
                        <div class="hide">
                            <div class="title">还剩{{nofinishNum}}题未完成</div>
                            <div class="challenge_progress">
                                <div class="progress_div" v-if="step === 1">
                                    <img class="img" src="../../src/assets/images/challenge_progress_bg.png">
                                    <img class="center_img" src="../../src/assets/images/challenge_default_img.png">
                                    <div class="progress_item1"
                                         :class="currIndex === 0 ? 'current_progress_item' : (isEnd || submitData[0].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(0)" v-if="submitData.length > 0">
                                        <span class="num">1</span>
                                    </div>
                                    <div class="progress_item2"
                                         :class="currIndex === 1 ? 'current_progress_item' : (isEnd || submitData[1].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(1)" v-if="submitData.length > 1">
                                        <span class="num">2</span>
                                    </div>
                                    <div class="progress_item3"
                                         :class="currIndex === 2 ? 'current_progress_item' : (isEnd || submitData[2].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(2)" v-if="submitData.length > 2">
                                        <span class="num">3</span>
                                    </div>
                                    <div class="progress_item4"
                                         :class="currIndex === 3 ? 'current_progress_item' : (isEnd || submitData[3].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(3)" v-if="submitData.length > 3">
                                        <span class="num">4</span>
                                    </div>
                                    <div class="progress_item5"
                                         :class="currIndex === 4 ? 'current_progress_item' : (isEnd || submitData[4].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(4)" v-if="submitData.length > 4">
                                        <span class="num">5</span>
                                    </div>
                                    <div class="progress_item6"
                                         :class="currIndex === 5 ? 'current_progress_item' : (isEnd || submitData[5].isfinish) ? 'finished_progress_item' : 'unfinished_progress_item'"
                                         @click="changeTopicNum(5)" v-if="submitData.length > 5">
                                        <span class="num">6</span>
                                    </div>
                                </div>
                            </div>

                            <div id="dian" v-if="step === 1 && nofinishNum === 0">
                                <el-button
                                        class="finish_btn"
                                        type="primary"
                                        size="medium"
										:disabled="isSubmitting"
                                        @click="endAnswer"
                                >
                                    {{con}}
                                </el-button>
                            </div>


                            <!--                            <div @click="nextTopic" id="dian" v-if="step === 1 && nofinishNum === 0 && !isDisabled"-->
                            <!--                                 v-bind:class="{ you: flag, you2: !flag }">-->
                            <!--                                {{con;}}-->
                            <!--                            </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="top">
                <div class="hill">
                    <div>
                        <img class="img3" src="../../src/assets/images/u36.png"/>
                    </div>
                </div>
                <div class="train">
                    <div>
                        <img class="img3" src="../../src/assets/images/u36.png"/>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="railway">
                    <img class="img4" src="../../src/assets/images/u1.png"/>
                </div>
            </div>
        </div>
        <div v-if="step === 2" class="Subject_right_float">
            <div class="Popup">
                <span @click="centerDialogVisible = true">结束练习</span>
                <el-dialog
                        v-if="step === 1"
                        :visible.sync="centerDialogVisible"
                        :modal="false"
                        top="35vh"
                        width="432px"
                        custom-class="EscModal"
                >
                    <div class="Tips">
                        <div class="top">
                            <p class="p1"><span class="warning">!</span> 退出训练则成绩无效</p>
                            <p class="p2">答完所有题目，确认交卷后才会获得评测结果</p>
                        </div>
                        <div class="btn_div">
                            <div class="btn1">
                                <el-button type="primary btn" @click="centerDialogVisible = false">继续训练
                                </el-button>
                                <el-button type="primary btn" @click="signOut">退出训练</el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>
                <el-dialog
                        v-if="step === 2"
                        :visible.sync="centerDialogVisible"
                        :modal="false"
                        top="35vh"
                        width="432px"
                        custom-class="EscModal"
                >
                    <div class="Tips">
                        <div class="top">
                            <p class="p1">历史最高成绩</p>
                            <div class="center">
                                <img class="img" :src="basicsData.highestLevelImgUrl">
                            </div>
                        </div>
                        <div class="btn_div">
                            <div class="btn1">
                                <el-button type="primary btn" @click="onceAgain">继续训练
                                </el-button>
                                <el-button type="primary btn" @click="signOut">退出训练</el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="times">
                <div class="title_name">答题时间</div>
                <div class="title_time">
                    <div ref="startTimer">{{basicsData.totalLongOfTime}}</div>
                </div>
            </div>
            <!-- 点击提交后的样式 -->
            <div class="hides" v-if="step === 2">
                <div class="hide">
                    <div class="line"></div>
                    <div class="questions">
                        <div class="correct">
                            <p class="number">{{basicsData.rightNum}}</p>
                            <p class="name">正确</p>
                        </div>
                        <div class="error">
                            <p class="number">{{basicsData.errorNum}}</p>
                            <p class="name">错误</p>
                        </div>
                    </div>
                    <div class="challenge_progress">
                        <div class="progress_div" v-if="step === 2">
                            <img class="img" src="../../src/assets/images/challenge_progress_bg.png">
                            <img class="center_img fade-in-simple" v-if="basicsData.levelImgUrl" :src="basicsData.levelImgUrl"
                                 alt>
                            <img class="center_img" v-if="!basicsData.levelImgUrl"
                                 src="../../src/assets/images/challenge_default_img.png" alt>
                            <div class="progress_item1"
                                 :class="topicDetail[0] ? topicDetail[0].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(0)" v-if="submitData.length > 0">
                                <span class="num">1</span>
                            </div>
                            <div class="progress_item2"
                                 :class="topicDetail[1] ? topicDetail[1].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(1)" v-if="submitData.length > 1">
                                <span class="num">2</span>
                            </div>
                            <div class="progress_item3"
                                 :class="topicDetail[2] ? topicDetail[2].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(2)" v-if="submitData.length > 2">
                                <span class="num">3</span>
                            </div>
                            <div class="progress_item4"
                                 :class="topicDetail[3] ? topicDetail[3].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(3)" v-if="submitData.length > 3">
                                <span class="num">4</span>
                            </div>
                            <div class="progress_item5"
                                 :class="topicDetail[4] ? topicDetail[4].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(4)" v-if="submitData.length > 4">
                                <span class="num">5</span>
                            </div>
                            <div class="progress_item6"
                                 :class="topicDetail[5] ? topicDetail[5].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
                                 @click="changeTopicNum(5)" v-if="submitData.length > 5">
                                <span class="num">6</span>
                            </div>
                        </div>
						<!-- 金币容器 -->
						<div class="coins-container">
							<div v-for="(coin, index) in coins"
								 :key="'coin-'+index"
								 class="coin"
								 :style="{
                         top: coin.y + 'px',
                         left: coin.x + 'px',
                         transform: `scale(${coin.scale}) rotate(${coin.rotation}deg)`,
                         opacity: coin.opacity
                     }">
							</div>
						</div>

						<!-- 收集的金币 -->
						<div class="coins-collected">
							<div v-for="(_, index) in collectedCoins" :key="'collected-'+index" class="collected-coin">¥</div>
						</div>
						<!-- 福袋按钮（新增） -->
						<div class="fortune-bag-btn" v-if="basicsData.playCoinsAnimationFlag == 2">
							<img src="../../src/assets/images/fortune_bag.png" alt="福袋">
						</div>

                    </div>
                    <div class="tips">{{ basicsData.remark ? basicsData.remark :"继续努力，加油！"}}</div>
                    <div class="again">
                        <div @click="onceAgain" class="btn">再次挑战</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <el-dialog
                    :title="currentKnowledge.name"
                    :visible.sync="dialogVisible"
                    width="580px"
                    :before-close="handleClose"
            >
                <div class="video_div">
                    <video
                            v-if="videoUrl"
                            :src="videoUrl.split(',')[0]"
                            controls="controls"
                            controlslist="nodownload noremoteplayback"
                            width="536px"
                            height="288px"
                            :disablePictureInPicture="true"
                            autoplay="autoplay"
							oncontextmenu="return false"
                    ></video>
                    <div class="no_videoUrl" v-if="!videoUrl">
                        <span>暂无视频讲解</span>
                    </div>
                    <div class="video_operation"  v-if="currentVideoDialogType === 'knowledge' && videoUrl">
                        <div :class="currentVideoIndex === i ? 'selected-div' : 'default-div'"
                             v-for="(item, i) in currentVideoArr" :key="i"
                             @click="changeVideoUrl(i, item.videoUrl)">
                            {{item.name}}
                        </div>
<!--                        <span :class="currentVideoIndex === i ? 'active_text' : 'text'"-->
<!--                              v-for="(item, i) in currentVideoArr" :key="i"-->
<!--                              @click="changeVideoUrl(i, item.videoUrl)">-->
<!--                            {{item.name}}-->
<!--                        </span>-->
                    </div>
                    <div class="bottom_analysis" v-html="currentKnowledge.analysis ? currentKnowledge.analysis : (currentKnowledge.examAnalysis?currentKnowledge.examAnalysis:'暂无分析')"/>

                </div>
<!--                <span slot="footer" class="dialog-footer">-->
          <!-- <el-button @click="dialogVisible = false">没看懂</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >看懂了</el-button
          > -->
<!--                </span>-->
            </el-dialog>
        </div>
        <div v-if="step === 2 && basicsData.isFinishTask && showMoneyAnimate" class="mask"/>
        <div v-if="step === 2 && basicsData.isFinishTask && showMoneyAnimate" class="money_animate"/>
    </div>
</template>

<script>
    import Header from "../components/common/Header";
    import api from "../axios/interface";
	import LoadingAnimation from "./LoadingAnimation.vue";
	import marked from 'marked';
	import katex from 'katex';
	import 'katex/dist/katex.min.css';
	// 导入KaTeX自动渲染（用于公式渲染）
	import renderMathInElement from 'katex/dist/contrib/auto-render.mjs';
	// 防XSS依赖（渲染HTML必备）
	import DOMPurify from 'dompurify';
	// 配置DOMPurify：允许KaTeX的核心标签和属性
	const purifyConfig = {
		ALLOWED_TAGS: [
			// 对话框/页面结构标签
			'div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
			'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
			// Markdown元素：代码块、引用、强调
			'pre', 'code', 'blockquote', 'em', 'strong', 'a',
			// KaTeX公式标签
			'span', 'nobr', 'mrow', 'mi', 'mo', 'mn', 'mspace', 'mstyle', 'math'
		],
		// 允许的属性：保留样式、ID、类等
		ALLOWED_ATTR: [
			'class', 'style', 'id', 'name', 'href', 'target',
			'xmlns', 'cellpadding', 'cellspacing', 'colspan', 'rowspan'
		],
	};

	window.DOMPurify = DOMPurify;
	window.purifyHTML = (html) => DOMPurify.sanitize(html, purifyConfig); // 暴露净化函数
	// 全局挂载必需的渲染工具（供渲染方法使用）
	window.renderMathInElement = renderMathInElement;
	window.marked = marked;

	// 初始化marked配置（只执行一次，全局生效）
	const customMarkedRenderer = new marked.Renderer();
	// 自定义代码块渲染（保持代码高亮兼容性）
	customMarkedRenderer.code = (code, lang) => `<pre><code class="language-${lang || ''}">${code}</code></pre>`;
	// 禁止marked处理$、\等公式特殊字符（交给KaTeX处理）
	customMarkedRenderer.text = (text) => text;

	marked.setOptions({
		breaks: true,        // 支持换行
		gfm: true,           // 支持GitHub Flavored Markdown
		tables: true,        // 支持表格
		sanitize: false,     // 不自动过滤HTML（后续用DOMPurify过滤）
		escape: false,       // 禁止转义反斜杠、$等特殊字符
		mangle: false,       // 不混淆邮箱
		headerPrefix: '',    // 清除标题ID前缀
		renderer: customMarkedRenderer
	});
	export default {
        name: "Challenge",
        components: {
            Header: Header,
			LoadingAnimation
        },
        props: {
            time: {
                type: Number
            }
        },
        data() {
            return {
                con: "交卷",
                flag: false,
                centerDialogVisible: false,
                problemsPopover: false,
				isSubmitting: false,
                textarea: [],
				fortuneInterval: null,
				animationFrameId: null, // 存储动画帧ID
				isAnimating: false,       // 动画状态标志
				inputTextarea: "",
                quiz: [
                    {
                        subject:
                            "1.幼儿社会领域的学习与发展是在人际交往和社会环境的相互合作中进行的，在人际交往和社会适应过程中，幼儿进行社会学习的主要方式在人际交往和社会适应过程中在人际交往和社会适应过程中，幼儿进行社会学习的主要方式，幼儿进行社会学习的主要方式不包括()",
                        items: [
                            "应注重引导幼儿通过直接感知、亲身体验和实际操作进行科学学习"
                        ],
                        ans: "A"
                    },
                    {
                        subject: "2.市值最高的公司",
                        items: ["中国移动", "阿里巴巴", "可口可乐", "苹果"],
                        ans: "D"
                    },
                    {
                        subject: "3.儿童数概念的形成，经历的四个阶段分别是()。",
                        items: [
                            "口头数数一按数取物一给物说数一掌握数概念",
                            "口头数数一按数取物一给物说数一掌握数概念"
                        ],
                        ans: "C"
                    },
                    {
                        subject:
                            "4.下列选项不属于《3－6岁儿童学习与发展指南》中健康领域目标的是()",
                        items: [
                            "愿意与人交往"
                        ],
                        ans: "A"
                    },
                    {
                        subject:
                            "5.音乐欣赏作品的艺术形象应积极向上，有助于陶冶与丰富幼儿的心灵，激发幼儿热爱生活的愿望，熏陶幼儿健康的审美情趣，反应了幼儿音乐欣赏作品选择要求的()。",
                        items: ["审美性", "教育性", "适宜性", "多样性"],
                        ans: "A"
                    },
                    {
                        subject:
                            "6.菲菲在幼儿园绘画活动中用很长的波浪线画小草，王老师认为她画得不像，教她用三根小短线形成的三叉作为小草，这更像现实生活中的小草。王老师的做法()。",
                        items: [
                            "过于强调画画技能，损害了幼儿的绘画兴趣"
                        ],
                        ans: "A"
                    },
                    {
                        subject:
                            "7.王老师在组织“6”的分解、组成活动时，为幼儿提供了小棒、积木和圆片等学具供其操作，王老师的做法体现的学前教育原则是()。",
                        items: ["长江", "尼罗河", "黄河", "京杭大运河"],
                        ans: "A"
                    },
                    {
                        subject: "8.最长的河",
                        items: [
                            "保教合一的原则",
                            "以游戏为主要目的原则",
                            "教育的活动性和直观性原则",
                            "生活化和一日活动整体性原则"
                        ],
                        ans: "A"
                    },
                    {
                        subject: "9.世界儿童文学制作的正式开端为()。",
                        items: [
                            "《鹅妈妈的故事》",
                            "《海的女儿》",
                            "《讲给孩子们听的故事》",
                            "《丑小鸭》"
                        ],
                        ans: "C"
                    },
                    {
                        subject: "10.幼儿园教育活动的设计和实施主要体现()。",
                        items: [
                            "趣味性、综合性和生活化",
                            "趣味性、新颖性和生活化",
                            "新颖性、综合性和儿童化",
                            "新颖性、游戏性和儿童化"
                        ],
                        ans: "C"
                    }
                ],
                progress: 0,
                itemsValue: ["A", "B", "C", "D"],
                answer: "",
                answers: new Map(),
                submitted: false,
                score: 0,
                multiAnswer: [],
                size: 10,

                TopicData: [],
				skipData: [0,0,0,0,0,0,0,0,0,0],
				skipFNFlag: true,
                step: 1,
                currIndex: 0,
                radioValue: "", // 当前单选题选项
                checkList: [], // 当前选择数组
                judgeOption: "",
                timer: null,
                topicTimer: null,
                oneTopicTimer: 0,
                content: "",
                hour: 0,
                minutes: 0,
                seconds: 0,
                currtimer: 0, // 当前计时
                judgeData: [{isAnswer: 0}, {isAnswer: 1}],
                sectionId: this.$route.query.sectionId,
                subjectId: this.$route.query.subjectId,
                taskId: this.$route.query.taskId,
                type: this.$route.query.type,
                sectionName: this.$route.query.name,
                isDisabled: true, // 是否可以点击下一题
                errorGroupId: "", // 题组id
                params: {},
                paramsItem: {},
                groupIdInfo: {},
                groupIdTotal: 0,
                topicDetail: [],
                dialogVisible: false,
				examAnalysisDialogVisible: false,
				AIAnalysisDialogVisible: false,
                videoUrl: "",
                submitData: [],
                basicsData: {},
				coins: [],
				animationFrames: [], // 新增：存储所有动画帧请求
				collectedCoins: 0,
                isEnd: false,
                currentVideoArr: [],
                currentVideoIndex: 0,
                currentKnowledge: "",
                currentVideoDialogType: "",
                currentSelectedItem: {},
				showMoneyAnimate: false, // 是否展示金币动画
				showMoneyAnimateTimer: null,
				aiExamAnalysis: '', // AI解析结果（渲染后的HTML）
				stContent1: '',     // 试题原文内容
				examAnalysis: '',
				isAnalyzing: false, // 是否正在解析（防止重复请求）
				analysisError: "",  // 解析错误信息
				isKaTeXReady: true, // KaTeX是否可用标记
				rawMarkdown: "",    // 后台返回的原始Markdown文本
				currentAIAnalysisId: "", // 当前解析的试题ID
				timeoutTimer: null, // 超时计时器
				debounceRender: null // KaTeX渲染防抖计时器
            };
        },
        created() {
			try {
				// 验证KaTeX核心方法（使用import引入的变量，而非window）
				if (!katex || !renderMathInElement) {
					throw new Error("KaTeX 核心方法缺失");
				}
				this.isKaTeXReady = true;
			} catch (err) {
				this.isKaTeXReady = false;
				console.error("KaTeX 初始化失败：", err);
				this.analysisError = "公式渲染功能暂不可用，请确保已安装katex依赖（npm install katex）";
			}
		},
		beforeDestroy() {
			// 组件销毁时清理所有资源
			this.resetAnalysisState(true);
		},
        computed: {
            nofinishNum() {
                let num = 0;
                this.submitData.forEach((item) => {
                    if (Number(item.isfinish) === 0) {
                        num = num + 1;
                    }
                });
                return num;
            }
        },
        updated() {
            this.initData();
        },
		// 组件销毁时清理
		beforeUnmount() {
			this.stopAnimation();
			if (this.fortuneInterval) clearInterval(this.fortuneInterval);
		},
        mounted() {
        	this.initSkipData();
            this.getTopic();
			// 检查KaTeX是否加载完成
			// this.isKaTeXReady = window.katex && window.renderMathInElement;
			// if (!this.isKaTeXReady) {
			// 	console.warn("KaTeX 未加载完成，公式渲染功能不可用");
			// }
            // this.init()
			this.calculateContainerSize();
			window.addEventListener('resize', this.calculateContainerSize);
        },
        methods: {
        	initSkipData(){
        		let that = this;
				this.$axios.get(api.GETSKIPEXAMNUMTODAY,
					{bodyType: "form", hideMessage: true}
				).then(res => {
					if (res.result && res.result.total && res.result.total >4){
						that.skipFNFlag = false
					}
				}).catch(error => {
				});
			},
        	initData() {
				let that = this;
				// 如果是选择题则在页面渲染完成后给input添加事件
				if (this.TopicData[this.currIndex] && this.TopicData[this.currIndex].examType && this.TopicData[this.currIndex].examType == 3) {
					this.$nextTick().then(() => {
						$(".tiankong").on("blur", function (e) {
							this.setAttribute("value",this.value);
							let examCurrIndex = that.currIndex;
							that.TopicData[examCurrIndex].content = $("#content_"+examCurrIndex).html();
							if (this.value) {
								that.clickOption();
							}
						});
						$(".tiankong").on("input", function (e) {
							if (this.value) {
								if (this.value.length > 4) {

									this.size = this.size < 648 ? this.size + 1 : this.size;
									if(this.style.width==""){
										this.style.width="60px";
									}
									this.style.width = parseFloat(this.style.width.split('px')[0]) + Math.round(800/this.value.length)/100 + "px";
								}
								that.clickOption();
							}
						});
					});
				}
			},
            onImproveProblems(item) {
                this.problemsPopover = true;
                this.currentSelectedItem = item;
            },
            problemDialogClosed() {
                this.textarea = [];
                this.inputTextarea = "";
            },
            onceAgain() {
                if (this.centerDialogVisible) {
                    this.centerDialogVisible = false;
                }
                this.skipData = [0,0,0,0,0,0,0,0,0,0];
                this.skipFNFlag = true;
				this.initReturnData()

                // this.$router.go(0);
				this.getTopic();
				// this.initData();
				// let num = 0;
				// this.submitData.forEach((item) => {
				// 	if (Number(item.isfinish) === 0) {
				// 		num = num + 1;
				// 	}
				// })
				// this.nofinishNum =  num;
            },
            stop() {
                clearInterval(this.timer);
            },
            start() {
                this.timer = setInterval(this.startTimer, 1000);
            },
            //下一题
            next: function () {
                if (this.progress < this.size) {
                    this.answers.set(this.progress, this.answer);
                    this.progress++;
                    this.answer = "";
                } else if (this.progress < this.quiz.length) {
                    this.answers.set(this.progress, this.multiAnser);
                    this.progress++;
                    this.multiAnser = [];
                }
            },
            //提交答案
            //submit: function () {
            //},
            //返回
            back: function () {
            },
            enter: function () {
                this.nextTopic();
                this.flag = !this.flag;
                if (this.flag == true) {
                    this.con = "继续挑战";
                } else if (this.flag == false) {
                    this.con = "交卷";
                }
            },

            init() {
                if (this.step == 2) {
                    let timerdiv = $("#timerdiv");
                    let topic2 = $("#topic_step2");
                    let topic2Top = topic2.offset().top;
                    let timerTop = timerdiv.offset().top;
                    $.event.add(window, "scroll", () => {
                        let p = $(window).scrollTop();
                        if (p > timerTop && p > topic2Top) {
                            // 到顶部
                            timerdiv.css("position", "fixed");
                            timerdiv.css("top", 0);
                            timerdiv.css("height", "610px");
                            timerdiv.css("margin-left", "672px");
                        } else {
                            timerdiv.css("position", "rilative");
                            timerdiv.css("margin-left", "48px");
                        }
                    });
                }
            },
            // 获取挑战做题数据统计接口
            getTopic() {
                let that = this;
                let url, params;
                if (this.type == 1) {
                    url = api.CHALLENGEBYCAPTER;
                    params = {sectionId: this.sectionId};
                } else {
                    url = api.CHALLENGEBYTASK;
                    params = {taskId: this.taskId};
                }
                this.$axios.get(url, params,
                    {hideMessage: true}
                )
                    .then(res => {
                        clearInterval(this.timer);
                        this.timer = setInterval(this.startTimer, 10);
                        res.result.data.map(item => {
                            if (item.examType == 3) {
                                item.content = item.content.replace(
                                    /\[Space\]/g,
                                    "<input type=\"text\" class=\"tiankong\"></input>"
                                );
                            }
                        });
                        this.TopicData = res.result.data;
                        this.groupIdTotal = res.result.data.length;
                        res.result.data.forEach((item, index) => {
                            this.submitData.push({id: item.id, isfinish: 0});
                            // 多选题每题独立维护勾选数组，避免共用全局 checkList 导致相邻多选题选项id串题
                            if (item.examType == 2) {
                                this.$set(this.paramsItem, 'val' + index, []);
                            }
                        });
                    })
                    .catch(res => {
                    });
            },

            Refresh() {
                this.$router.go(0);
            },

            goHome() {
                this.$router.push({
                    name: "Home",
                    query: this.subjectId
                });
            },

            handleClose() {
                this.dialogVisible = false;
				this.examAnalysisDialogVisible = false;
				this.AIAnalysisDialogVisible = false;
				this.aiExamAnalysis = "";
				this.videoUrl = ""; // 若模板中无videoUrl可删除
				this.analysisError = "";
				this.resetAnalysisState(true);
            },
			openExamAnalysis(examAnalysis, similar) {
				if (examAnalysis && examAnalysis !== "") {
					this.examAnalysis = examAnalysis;
				} else if (similar && similar.video.length > 0 && !!similar.video[0].analysis) {
					this.examAnalysis = similar.video[0].analysis;
				}
				this.examAnalysisDialogVisible = true;
			},
			openAIAnalysis(id) {
				if (this.isAnalyzing) return;
				this.isAnalyzing = true;

				// 1. 检查依赖
				if (!window.marked || !window.renderMathInElement || !window.DOMPurify) {
					this.analysisError = "依赖缺失：请加载 marked、KaTeX 渲染库和 DOMPurify";
					this.AIAnalysisDialogVisible = true;
					this.isAnalyzing = false;
					return;
				}

				// 2. 初始化状态
				this.currentAIAnalysisId = id;
				const stContentRef1 = this.$refs[`st1_${id}`];
				this.stContent1 = stContentRef1 ? stContentRef1[0].innerHTML : "";

				this.rawMarkdown = "";
				this.analysisError = "";
				this.AIAnalysisDialogVisible = true;
				this.resetAnalysisState(true);

				// 3. 设置超时
				this.timeoutTimer = setTimeout(() => {
					if (this.isAnalyzing) {
						this.analysisError = "解析超时，请重试";
						this.resetAnalysisState(true);
					}
				}, 90000);

				try {
					// ✅ 4. 发起请求
					const randomParam = new Date().getTime();
					const requestUrl = `${api.AIAnalysis}?id=${id}&t=${randomParam}`;
					fetch(requestUrl, {
						method: "GET",
						headers: { "Accept": "text/markdown", "Cache-Control": "no-cache" },
						credentials: "omit"
					})
						.then(response => {
							if (!response.ok) {
								return response.text().then(errorText => {
									throw new Error(errorText || `请求失败：${response.status} ${response.statusText}`);
								});
							}
							return response.text();
						})
						.then(markdown => {
							this.rawMarkdown = markdown;

							// ========== 第0步：分隔符"反转义层"，归一化AI返回的各种形态 ==========
							// AI(豆包) 可能返回 \\$...\\$（$被多转义一层），marked 会输出字面 \$，
							// KaTeX 不认识 \$ 定界符，公式就原样显示成字符串。统一在处理前归一化：
							let normalizedMarkdown = markdown
								// $ 前的一个或多个反斜杠一律去掉：\\$、\$ → $
								.replace(/\\+\$/g, '$')
								// 两个及以上反斜杠 + ( ) [ ] 归一为一个：\\( → \(、\\\\[ → \[
								// 单反斜杠的 \(...\)、\[...\] 本身就是合法定界符，不动它
								.replace(/\\{2,}([()\[\]])/g, '\\$1');

							// ========== 第1步：在归一化后的原始markdown上提取并保护LaTeX公式 ==========
							// 必须在 DOMPurify 之前提取，否则 < > & 会被转义、反斜杠会被 marked 吃掉
							const mathPlaceholders = [];
							// $$..$$ 必须在 $..$ 之前；\(..\)、\[..\] 一并保护
							const mathReg = /(\$\$[\s\S]*?\$\$)|(\\\([\s\S]*?\\\))|(\\\[[\s\S]*?\\\])|(\$[^$\n]*?\$)/g;
							const protectedMarkdown = normalizedMarkdown.replace(mathReg, (match) => {
								const placeholder = `MATHPLACEHOLDER${mathPlaceholders.length}ENDMATH`;
								// 兼容AI直接返回HTML实体（如 $k&lt;0$ → $k<0$），&amp; 最后替换
								const decoded = match
									.replace(/&lt;/g, '<')
									.replace(/&gt;/g, '>')
									.replace(/&quot;/g, '"')
									.replace(/&#39;/g, "'")
									.replace(/&nbsp;/g, ' ')
									.replace(/&amp;/g, '&');
								mathPlaceholders.push(decoded);
								return placeholder;
							});

							// ========== 第2步：只对非公式文本做 XSS 净化和 markdown 解析 ==========
							const safeMarkdown = window.DOMPurify.sanitize(protectedMarkdown);
							let html = marked.parse(safeMarkdown);

							// ========== 第3步：直接用 katex.renderToString 渲染公式 ==========
							// 在字符串阶段就把公式转成 KaTeX HTML，v-html 注入即渲染完成
							html = html.replace(/MATHPLACEHOLDER(\d+)ENDMATH/g, (_, idx) => {
								const raw = mathPlaceholders[idx];
								try {
									// $$..$$ 和 \[..\] 是行间(display)，其余是行内(inline)
									const isDisplay = raw.startsWith('$$') || raw.startsWith('\\[');
									// 去掉定界符，提取纯 LaTeX
									const tex = raw
										.replace(/^\$\$/, '').replace(/\$\$$/, '')
										.replace(/^\$/, '').replace(/\$$/, '')
										.replace(/^\\\(/, '').replace(/\\\)$/, '')
										.replace(/^\\\[/, '').replace(/\\\]$/, '');
									return katex.renderToString(tex, {
										displayMode: isDisplay,
										throwOnError: false,
										strict: 'ignore',
										trust: true
									});
								} catch (e) {
									console.error('KaTeX渲染失败:', e, '公式:', raw);
									return raw;  // 失败时返回原始 LaTeX 文本
								}
							});

							this.aiExamAnalysis = html;
							this.analysisError = "";
						})
						.catch(error => {
							this.analysisError = error.message.startsWith("ERROR:")
								? error.message.slice(6)
								: error.message;
							this.aiExamAnalysis = "";
							console.error("AI解析失败：", error);
						})
						.finally(() => {
							clearTimeout(this.timeoutTimer);
							this.timeoutTimer = null;
							this.isAnalyzing = false;
							setTimeout(() => {
								this.resetAnalysisState(false);
							}, 1000);
						});

				} catch (err) {
					console.error("请求初始化异常：", err);
					this.analysisError = err.message || "连接失败，请重试";
					this.resetAnalysisState(true);
				}
			},

			// 重置状态
			resetAnalysisState(clearChunks = true) {
				this.isAnalyzing = false;
				if (this.timeoutTimer) clearTimeout(this.timeoutTimer);
				if (this.debounceRender) clearTimeout(this.debounceRender);

				this.timeoutTimer = null;
				this.debounceRender = null;

				if (clearChunks) this.rawMarkdown = "";
			},
			openVideo(type, item, examAnalysis) {
                let that = this;
                this.currentKnowledge = item;
                this.currentKnowledge.examAnalysis = examAnalysis
                this.currentVideoDialogType = type;
                if (item.video.length > 0) {
                    this.currentVideoArr = item.video;
                    this.dialogVisible = !!item.video[0].videoUrl;
                    if (item.video[0].videoUrl) {
                        that.changeVideoUrl(0, item.video[0].videoUrl);
                    }

                }
            },

            changeTopicNum(num) {
                if (this.step == 1) {
                    this.currIndex = num;
                } else if (this.step == 2) {
                    $("html,body").animate({
                        scrollTop: $(`#topic${num}`).offset().top - 50
                    }, 400);
                }

            },

            // 选择题选项
            clickOption(val) {
        		// console.log("clickOption:" + this.TopicData[this.currIndex].examType + "=======" + val)
                let that = this;
                if (this.TopicData[this.currIndex].examType == 1) {
                    // 单选题
                    this.isDisabled = false;
                    this.params = {
                        answers: String(val),
                        examType: 1,
						currIndex: this.currIndex,
                        id: this.TopicData[this.currIndex].id
                    };
                    if (this.currIndex + 1 != this.TopicData.length) {
                        this.nextTopic();
                    } else {
                        // 最后一题只提交答案
                        this.submit(this.params);
                    }
                } else if (this.TopicData[this.currIndex].examType == 2) {
                    // 每题独立勾选数组，切题互不干扰
                    let multiList = this.paramsItem['val' + this.currIndex] || [];
                    if (multiList.length > 1) {
                        this.isDisabled = false;
                    } else {
                        this.isDisabled = true;
                    }
                    let answerIds = multiList.join(";");
                    this.params = {
                        answers: answerIds,
                        examType: 2,
						currIndex: this.currIndex,
                        id: this.TopicData[this.currIndex].id
                    };
					// if (this.currIndex + 1 != this.TopicData.length) {
						// this.nextTopic();
					// } else {
						// 最后一题只提交答案
						this.submit(this.params);
					// }
                } else if (this.TopicData[this.currIndex].examType == 4) {
                    // 判断题
                    this.params = {
                        answers: String(val),
                        examType: 4,
						currIndex: this.currIndex,
                        id: this.TopicData[this.currIndex].id
                    };
                    this.isDisabled = false;
                    if (this.currIndex + 1 != this.TopicData.length) {
                        this.nextTopic();
                    } else {
                        // 最后一题只提交答案
                        this.submit(this.params);
                    }
                    this.judgeOption = "";
                } else if (this.TopicData[this.currIndex].examType == 3) {
                    // 填空题
                    let arr = $(".tiankong");
                    let brr = [];
                    for (let i = 0, j = arr.length; i < j; i++) {
                        brr.push(arr[i].value);
                    }
                    let answerInput = brr.join(";");
                    this.params = {
                        answers: answerInput,
                        examType: 3,
						currIndex: this.currIndex,
                        id: this.TopicData[this.currIndex].id
                    };
                    this.isDisabled = false;
                    this.submit(this.params);
                }
            },

			async skipTopic() {
				let that = this;
        		let total = 0;
        		for (const e of this.skipData){
        			total += e;
				}
        		if (total >= 2){
					this.$message({
						showClose: true,
						message: '本轮跳过试题数超过2个，无法跳过试题。',
						duration: 2000,
						type: 'info'
					});
        			return;
				}
        		let skipApiFlag = false;
				await this.$axios.get(api.GETSKIPEXAMNUMTODAY,
					{bodyType: "form", hideMessage: true}
				).then(res => {
						if (res.result && res.result.total && res.result.total >4){
							that.$message({
								showClose: true,
								message: '非常抱歉，当天提交试题有误次数超过5次，无法继续提交。',
								duration: 2000,
								type: 'info'
							});
							that.skipFNFlag = false
							skipApiFlag = true;
						}
					}).catch(error => {
				});
				if(skipApiFlag){
					return;
				}
				this.$confirm("提交试题有误后，将不可重新作答该题。是否确认？","提示",{
					iconClass: "el-icon-question",//自定义图标样式
					confirmButtonText: "确认",//确认按钮文字更换
					cancelButtonText: "取消",//取消按钮文字更换
					showClose: true,//是否显示右上角关闭按钮
					type: "warning",//提示类型  success/info/warning/error
				}).then(()=>{
					if(total == 1){
						that.skipFNFlag = false
					}
					//确认操作
					that.params = {
						answers: '',
						skipFlag: 1,
						examType: that.TopicData[that.currIndex].examType,
						currIndex: that.currIndex,
						id: that.TopicData[that.currIndex].id
					};
					that.skipData[that.currIndex] = 1;
					if (that.currIndex + 1 != that.TopicData.length) {
						that.nextTopic();
					} else {
						// 最后一题只提交答案
						that.submit(that.params);
					}
				}).catch(() => {
					//取消操作
				});
			},

            // 下一题
            nextTopic() {
            	//点击”下一题“按钮时，保存已填写的填空题答案
            	// let examCurrIndex = this.params.currIndex;
				// this.TopicData[examCurrIndex].content = $("#content_"+examCurrIndex).html();
                if (this.params.currIndex === this.currIndex) {
                    if (this.params.answers == 'undefined') {
                        this.currIndex = this.currIndex + 1;
                        return;
                    }
                } else {
                    this.currIndex = this.currIndex + 1;
                    return;
                }

                this.submit(this.params);
                // 如果当前题不是最后一题
                if (this.currIndex + 1 === this.TopicData.length) {
                    this.endAnswer();
                    // 跳转页面
                } else if (this.currIndex < this.TopicData.length) {
                    this.currIndex = this.currIndex + 1;
                    this.isDisabled = true;
                }
            },

            // 提交当前题目
            submit(params) {
                let nowTopictime;
                nowTopictime = this.oneTopicTimer;
                this.oneTopicTimer = 0;
                // this.startjishi()
                this.submitData = this.submitData.map((item, index) => {
                    if (item.id === this.TopicData[this.currIndex].id) {
                        item.answers = String(params.answers);
                        item.skipFlag = params.skipFlag;
                        item.isfinish = 1;
                        if (item.time) {
                            item.time = item.time + nowTopictime;
                        } else {
                            item.time = nowTopictime;
                        }
                        // console.log('item.time====', item.time)
                    }
                    return item;
                });

                // this.isDisabled = true;
            },

            // 结束订正
            endAnswer() {
				if (this.isSubmitting) return;
				try{
					this.isSubmitting = true;
					this.isEnd = true;
					let url, params;
					setTimeout(() => {
						this.step = 2;
					}, 1200);
					clearInterval(this.timer);
					let arr = this.submitData;
					arr.forEach(e => {
						delete e.isfinish;
					});
					let answerData = JSON.stringify(arr);
					// 交卷
					if (this.type == 1) {
						url = api.CHALLENGEBYCAPTERSUBMIT;
						params = {
							sectionId: this.sectionId,
							answer: answerData
						};
					} else {
						url = api.CHALLENGEBYTASKSUBMIT;
						params = {
							taskId: this.taskId,
							answer: answerData
						};
					}
					this.$axios.post(url, params,
						{bodyType: "form", hideMessage: true}
					)
						.then(res => {
							this.topicDetail = res.result.data ? res.result.data : [];
							this.basicsData = res.result;
							// 完成了当前任务，则展示动画
							if (this.basicsData && this.basicsData.isFinishTask) {
								this.showMoneyAnimate = true;
								this.showMoneyAnimateTimer = setInterval(() => {
									this.showMoneyAnimate = false;
								}, 3000);
							}
							// 展示动画
							if (this.basicsData && this.basicsData.playCoinsAnimationFlag) {
								if(this.basicsData.playCoinsAnimationFlag == 1){
									this.throwCoins(6, 7000);
								}else if(this.basicsData.playCoinsAnimationFlag == 2){
									this.throwCoins(15, 11000);
								}
							}
						}).catch(error => {
						}
					);
				} finally {
					setTimeout(() => {
						this.isSubmitting = false;
					}, 3000);
				}
            },
			f2() {
				this.basicsData.playCoinsAnimationFlag = 2
				this.throwCoins(15, 12000);
			},
			f1() {
				this.basicsData.playCoinsAnimationFlag = 1
				this.throwCoins(6, 7000);
			},
            GoBack() {
                this.$router.go(-1);
            },
            startTimer() {
                this.currtimer += 10;
                this.oneTopicTimer += 10;
                this.seconds += 10;
                if (this.seconds / 1000 >= 60) {
                    this.seconds = 0;
                    this.minutes = this.minutes + 1;
                }

                if (this.minutes >= 60) {
                    this.minutes = 0;
                    this.hour = this.hour + 1;
                }
                this.$refs.startTimer.innerHTML = (this.hour < 10 ? "0" + this.hour : this.hour) +
                    ":" +
                    (this.minutes < 10 ? "0" + this.minutes : this.minutes) +
                    ":" +
                    (Math.round(this.seconds / 1000) < 10 ? "0" + Math.round(this.seconds / 1000) : Math.round(this.seconds / 1000));
            },
            signOut() {
                if (this.type == 1) {
                    this.$router.push({
                        name: "subjecthome",
                        query: {subjectId: this.subjectId}
                    });
                } else {
                    this.$router.push({
                        name: "Home",
                        query: {}
                    });
                }
            },
            reportProblem(id) {
                let that = this;
                let feedbackContent = "";
                if(that.textarea.length>0 || that.inputTextarea != ""){
                	that.textarea.forEach((r)=>{
						feedbackContent += ";"+r;
					})
					feedbackContent = that.inputTextarea +feedbackContent;
					this.$axios.get(api.ErrorTopicFeedback, {id: this.currentSelectedItem.id, content: feedbackContent}, {hideMessage: true})
						.then(res => {
							that.problemsPopover = false;
							that.$message.success("反馈成功，非常感谢，我们会在第一时间进行处理！");
						});
				}else{
					that.$message.success("麻烦您完善一下反馈信息！");
				}
            },
            // 切换视频
            changeVideoUrl(index, url) {
                this.currentVideoIndex = index;
                this.videoUrl = url;
            },
			throwCoins(count, time) {
        		let that = this
				for (let i = 0; i < count; i++) {
					this.createCoin(i * 200); // 延迟创建金币
				}
				setTimeout(function(){
					that.clearAllCoins()
				}, time);
			},
			// // 清空金币方法（优化版）
			// clearAllCoins() {
			// 	this.basicsData.playCoinsAnimationFlag = ""
			// 	// 1. 取消所有动画帧
			// 	this.animationFrames.forEach(id => cancelAnimationFrame(id));
			// 	this.animationFrames = [];
			//
			// 	// 2. 清空数组
			// 	this.coins.splice(0, this.coins.length);
			//
			// 	// 3. 移除active类（关键！否则CSS动画会让金币短暂显示）
			// 	document.querySelectorAll('.coin').forEach(el => {
			// 		el.classList.remove('active');
			// 	});
			//
			// 	// 4. 强制更新（针对极端情况）
			// 	this.$nextTick(() => {
			// 		this.$forceUpdate();
			// 	});
			// },
			// 清空金币方法（逐个淡出版）
			clearAllCoins() {
				this.basicsData.playCoinsAnimationFlag = "";

				// 取消所有动画帧
				this.animationFrames.forEach(id => cancelAnimationFrame(id));
				this.animationFrames = [];

				// 获取所有金币元素并逐个添加淡出动画
				const coinElements = document.querySelectorAll('.coin');
				coinElements.forEach((el, index) => {
					// 逐个延迟淡出（每50ms一个）
					setTimeout(() => {
						el.classList.add('fade-out');

						// 最后一个金币淡出完成后清空数据
						if (index === coinElements.length - 1) {
							setTimeout(() => {
								this.coins.splice(0, this.coins.length);
								coinElements.forEach(el => el.classList.remove('active', 'fade-out'));
								this.$nextTick(() => this.$forceUpdate());
							}, 500);
						}
					}, index * 50); // 逐个延迟
				});
			},
			createCoin(delay) {
				setTimeout(() => {
					if (this.containerWidth === 0 || this.containerHeight === 0) {
						this.calculateContainerSize();
					}
					const coinSize = 40;
					const startX = this.containerWidth / 2 - coinSize / 2;
					const startY = this.containerHeight - coinSize - 20;
					const targetX = Math.random() * (this.containerWidth - 100);
					const targetY = 50 + Math.random() * (this.containerHeight / 2);

					const newCoin = {
						x: startX,
						y: startY,
						rotation: 0,
						scale: 1,
						opacity: 1,
						velocityY: -20 - Math.random() * 6, // 原：-12 - Math.random() * 4
						velocityX: (targetX - startX) / 25 + (Math.random() - 0.5) * 2,
						gravity: 0.2, // 原：0.4
						bounce: 0.7,
						bouncing: true
					};

					this.coins.push(newCoin);
					this.animateCoin(this.coins.length - 1);
				}, delay);
			},
			animateCoin(index) {
				const coin = this.coins[index];
				if (!coin) return;

				// 适配40px金币的动画参数
				coin.velocityY *= 1.0;  // 修改处2：从1.2改为1.0，适配40px尺寸
				coin.gravity *= 1.0;    // 修改处3：从0.9改为1.0，保持自然下落
				coin.bounce = 0.6;      // 修改处4：从0.5改为0.6，适度弹跳

				const animate = () => {
					const containerWidth = this.containerWidth;
					const containerHeight = this.containerHeight;
					const coinSize = 40; // 修改处5：60 → 40

					coin.x += coin.velocityX;
					coin.y += coin.velocityY;
					coin.velocityY += coin.gravity;
					coin.rotation += 4; // 修改处6：从5改为4，旋转速度适配40px

					if (coin.x < 0) {
						coin.x = 0;
						coin.velocityX *= -coin.bounce;
					} else if (coin.x > containerWidth - coinSize) {
						coin.x = containerWidth - coinSize;
						coin.velocityX *= -coin.bounce;
					}

					if (coin.y < 0) {
						coin.y = 0;
						coin.velocityY *= -coin.bounce;
					} else if (coin.y > containerHeight - coinSize) {
						coin.y = containerHeight - coinSize;
						coin.velocityY = -coin.velocityY * coin.bounce * 0.7;

						if (Math.abs(coin.velocityY) < 1.0) { // 修改处7：从1.2改为1.0，适配40px
							coin.bouncing = false;
							coin.velocityY = 0;

							setTimeout(() => {
								coin.scale = 0.9;
								coin.y = containerHeight - coinSize + 6; // 修改处8：从8改为6，适配40px

								setTimeout(() => {
									this.collectedCoins++;
									this.coins.splice(index, 1);
								}, 500);
							}, 300);
						}
					}

					if ((coin.y < containerHeight - coinSize || coin.bouncing) &&
						coin.x >= 0 && coin.x <= containerWidth - coinSize &&
						coin.y >= 0) {
						requestAnimationFrame(animate);
					}
				};

				this.animationFrames.push(requestAnimationFrame(animate));
			},
			calculateContainerSize() {
				// 改为获取整个窗口尺寸，而非某个容器
				this.containerWidth = window.innerWidth;
				this.containerHeight = window.innerHeight;
			},
			initReturnData(){
				this.con = "交卷"
				this.flag = false
				this.centerDialogVisible = false
				this.problemsPopover = false
				this.textarea = []
				this.inputTextarea = ""
				this.quiz = [
					{
						subject: "1",
						items: [""],
						ans: "A"
					},
					{
						subject: "2",
						items: [""],
						ans: "D"
					},
					{
						subject: "3",
						items: [""],
						ans: "C"
					},
					{
						subject: "4",
						items: [""],
						ans: "A"
					},
					{
						subject: "5",
						items: [""],
						ans: "A"
					},
					{
						subject: "6",
						items: [""],
						ans: "B"
					},
					{
						subject: "7",
						items: [""],
						ans: "A"
					},
					{
						subject: "8",
						items: [""],
						ans: "A"
					},
					{
						subject: "9",
						items: [""],
						ans: "A"
					},
					{
						subject: "10",
						items: [""],
						ans: "A"
					}
				],
					this.progress = 0
				this.itemsValue = ["A", "B", "C", "D"]
				this.answer = ""
				this.answers = new Map()
				this.submitted = false
				this.score = 0
				this.multiAnswer = []
				this.size = 10

				this.TopicData = []
				this.step = 1
				this.currIndex = 0
				this.radioValue = ""// 当前单选题选项
				this.checkList = []// 当前选择数组
				this.judgeOption = ""
				this.timer = null
				this.topicTimer = null
				this.oneTopicTimer = 0
				this.content = ""
				this.hour = 0
				this.minutes = 0
				this.seconds = 0
				this.currtimer = 0 // 当前计时
				this.judgeData = [{isAnswer: 0}, {isAnswer: 1}]
				this.sectionId = this.$route.query.sectionId
				this.subjectId = this.$route.query.subjectId
				this.taskId = this.$route.query.taskId
				this.type = this.$route.query.type
				this.sectionName = this.$route.query.name
				this.isDisabled = true // 是否可以点击下一题
				this.errorGroupId = "" // 题组id
				this.params = {}
				this.paramsItem = {}
				this.groupIdInfo = {}
				this.groupIdTotal = 0
				this.topicDetail = []
				this.dialogVisible = false
				this.examAnalysisDialogVisible = false
				this.videoUrl = ""
				this.submitData = []
				this.basicsData = {}
				this.isEnd = false
				this.currentVideoArr = []
				this.currentVideoIndex = 0
				this.currentKnowledge = ""
				this.currentVideoDialogType = ""
				this.currentSelectedItem = {}
				this.showMoneyAnimate = false // 是否展示金币动画
				this.showMoneyAnimateTimer = null
				this.examAnalysis = ''
			}
        },

        filters: {
            computedNum(val) {
                let option = "";
                switch (Number(val)) {
                    case 0:
                        option = "A";
                        break;
                    case 1:
                        option = "B";
                        break;
                    case 2:
                        option = "C";
                        break;
                    case 3:
                        option = "D";
                        break;
                    case 4:
                        option = "E";
                        break;
                    case 5:
                        option = "F";
                        break;
                    case 6:
                        option = "G";
                        break;
                    case 7:
                        option = "H";
                        break;
                    default:
                        option = "";
                        break;
                }
                return option;
            }
        },
        destroyed() {
            clearInterval(this.timer);
            if (this.showMoneyAnimateTimer) {
                clearInterval(this.showMoneyAnimateTimer);
            }
			window.removeEventListener('resize', this.calculateContainerSize);
        },
    };
</script>
<style>
	.skip_challenge {
		/*background-image: linear-gradient(to right, #30CFD0 0%, #330867 100%)!important;*/
		/*border: none;*/
		padding: 10px 20px!important;
		/*color: white;*/
	}
    .content_html .tiankong {
        padding: 0 10px;
        min-width: 60px;
        max-width: 360px;
        height: 22px;
        border: none;
        text-align: center;
        background-color: transparent;
        border-bottom: 1px solid #333333;
    }

    .answer_tiankong {
        padding: 0 10px;
        display: inline-block;
        width: 60px;
        height: 22px;
        text-align: center;
        background-color: transparent;
        border-bottom: 1px solid #333333;
    }

    .right {
        color: #1dc11d;
    }

    .error {
        color: #ff0000;
    }

    .content_html p input:focus {
        outline: none;
        border-bottom: 1px solid #333333 !important;
    }
</style>
<style lang="less" scoped>
    .container {
        background: #87C8FA;
        position: relative;
    }
	.skip_content {
		user-select: none;
		pointer-events: none;
		background-color: #efefef!important;
	}
    .money_animate {
        width: 100%;
        height: 100%;
        flex-wrap: nowrap;
        position: fixed;
        top: 0;
        left: 0;
        background: url("../assets/images/money_animate.gif") no-repeat;
        background-size: 100% 100%;
        z-index: 1000;
    }
    .mask {
        width: 100%;
        height: 100%;
        flex-wrap: nowrap;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.7);
    }
    .Subject_right_float {
        width: 340px;
        height: 100%;
        background-color: #333;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 50px;
        /*right: 6rem;*/
        /*min-height: 670px;*/
    }

    .challenge_content {
        width: 960px;
        margin: 80px 100px 150px 100px;
        min-height: 610px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .section_name {
            height: 32px;
            line-height: 32px;
            text-align: left;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .content_nav {
            min-height: 610px;
            width: 960px;
            display: flex;

            .topic {
                width: 768px;
                min-height: 610px;
                background-color: #fff;
                position: relative;
                border-radius: 4px;

                .title {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 40px;
                    /*background-color: #fff;*/

                    span {
                        font-size: 16px;
                        color: #333;
                        font-weight: 500;
                    }

                    .tipic_num {
                        display: inline-block;
                        width: 48px;
                        line-height: 40px;
                        height: 40px;
                        color: #fff;
                        text-align: center;
                        background-color: #333333;
                        border-radius: 4px 0 0px 0;
                    }

                    .tipic_desc {
                        display: inline-block;
                        width: 96px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        border-radius: 0 0 4px 0;
                        background-color: #0079FE;
                    }
                }

                .topic_content {
                    padding: 24px 50px 80px 24px;
                    color: #333333;
                    line-height: 22px;
                    .topic_option {
                        .option_item {
                            position: relative;
                            // 单选、判断
                            /deep/ .el-radio.is-bordered {
                                height: auto;
                            }

                            /deep/ .el-radio {
                                display: flex;
                                height: auto;
                                width: 550px;
                                max-width: 550px;
                                margin-top: 12px;
                                padding: 0px 0px 0 0;

                                &:first-child {
                                    // margin-top: 32px;
                                    margin-top: 15px;
                                }

                                .el-radio__input {
                                    display: none;
                                }

                                .el-radio__label {
                                    display: flex;
                                    line-height: 40px;
                                    padding: 0;

                                    .item_content {
                                        padding: 0 20px;
                                        max-width: 460px;
                                        overflow: hidden;
                                        white-space: pre-wrap;
                                    }

                                    .space {
                                        display: inline-block;
                                        text-align: center;
                                        width: 40px;
                                        height: auto;
                                        border-right: 1px solid #dcdfe6;
                                    }

                                    .judge_item {
                                        padding-left: 20px;
                                        width: 530px;
                                    }
                                }
                            }

                            // 多选
                            /deep/ .el-checkbox {
                                display: flex;
                                height: auto;
                                width: 550px;
                                max-width: 550px;
                                margin-top: 12px;
                                padding: 0px 0px 0 0;

                                &:first-of-type {
                                    margin-top: 32px;
                                }

                                .el-checkbox__input {
                                    display: none;
                                }

                                .el-checkbox__label {
                                    display: flex;
                                    line-height: 40px;
                                    padding: 0;

                                    .item_content {
                                        padding: 0 20px;
                                        max-width: 460px;
                                        overflow: hidden;
                                        white-space: pre-wrap;
                                    }

                                    .space {
                                        display: inline-block;
                                        text-align: center;
                                        width: 40px;
                                        height: auto;
                                        border-right: 1px solid #dcdfe6;
                                    }

                                    .judge_item {
                                        padding-left: 20px;
                                        width: 530px;
                                    }
                                }
                            }
                        }
                    }
                }

                .next {
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    background-color: #eeeeee;
                    height: 56px;
                    width: 100%;

                    .next_btn {
                        cursor: pointer;
                        padding: 0 15px;
                        font-size: 14px;
                        line-height: 28px;
                        margin-right: 48px;
                        margin: 12px 48px 12px 0;
                        height: 28px;
                        background-color: #0079fe;
                        color: #fff;
                        border-radius: 4px;
                    }
                    .isdisabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }

            .topic_step2 {
                width: 768px;
                min-height: 610px;
                background-color: #fff;
                position: relative;
                border-radius: 4px;

                .title {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 40px;
                    background-color: #fff;

                    span {
                        font-size: 16px;
                        color: #333;
                        font-weight: 500;
                    }

                    .tipic_num {
                        display: inline-block;
                        width: 48px;
                        line-height: 40px;
                        height: 40px;
                        color: #fff;
                        text-align: center;
                        background-color: #333333;
                        border-radius: 4px 0 0px 0;
                    }

                    .tipic_desc {
                        display: inline-block;
                        width: 96px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        border-radius: 0 0 4px 0;
                        background-color: #0079FE;
                    }
                }

                .topic_content {
                    padding: 24px 50px 24px 24px;
                    color: #333333;
                    line-height: 22px;

                    .topic_title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;

                        .content_html {
                            width: 420px;
                        }

                        .right,
                        .error {
                            display: inline-block;
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            text-align: center;
                            line-height: 28px;
                            color: #fff;
                            font-size: 28px;
                            font-weight: 600;
                        }

                        .right {
                            background-color: #1dc11d;
                        }

                        .error {
                            background-color: #ff0000;
                        }
                    }

                    .answer_div {
                        margin-top: 25px;
                        font-size: 14px;
                        font-weight: 500;

                        .answer {
                            color: #1dc11d;
                            display: inline-block;
                            border-bottom: 1px solid #1dc11d;
                            margin-right: 20px;
                        }
                    }

                    .topic_option {
                        margin-top: 15px;

                        .select_option {
                            display: flex;
                            margin-top: 5px;
                            border: 1px solid #DDDDDD;
                            align-items: center;
                            flex: 1;
                            border-radius: 6px;

                            .num {
                                width: 40px;
                                display: inline-block;
                                height: 100%;
                                text-align: center;
                                border-right: 1px solid #DDDDDD;
                            }

                            .select_content {
                                height: auto;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex: 1;
                                padding: 10px;
                                justify-content: space-between;

                                .type1AndType2Img {
                                    width: 32px;
                                    height: 32px;
                                    margin: -10px -26px -10px 0;
                                    background: white
                                }

                                .type4Img {
                                    width: 32px;
                                    height: 32px;
                                    margin: -10px -32px -10px 0;
                                    background: white
                                }
                            }

                            .right_icon {
                                background: #3BA9F6;
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                justify-self: flex-end;
                                margin: -10px -25px -10px 0px;
                                color: white;
                                display: flex;
                                align-items: center;
                                font-size: 26px;
                            }

                            .error_icon {
                                background: #FF0000;
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                justify-self: flex-end;
                                margin: -10px -25px -10px 0px;
                                color: white;
                                text-align: center;
                                font-size: 26px;
                            }

                            span {
                                &:first-of-type {
                                    margin-right: 5px;
                                }
                            }
                        }

                        .select_active {
                            border: 2px solid #0079FE;
                            border-radius: 6px;
                        }

                        .select_right {
                            color: #1dc11d;
                        }

                        .select_error {
                            color: #ff0000;
                        }

                        .select_Num {
                            border: 2px solid #0079FE;
                        }
                    }
                }

                .content_bottom {
                    margin: 0px 24px 54px 24px;

                    .fieldset {
                        border: 1px solid #eeeeee;
                        text-align: center;

                        .legend {
                            font-size: 16px;
                            color: #333333;
                            padding: 0 22px;
                        }

                        .zhishidian {
                            padding: 8px 24px;
                            display: flex;
                            cursor: pointer;

                            .item {
                                padding: 0 12px;
                                margin-right: 20px;
                                height: 30px;
                                line-height: 30px;
                                color: #333333;
                                font-size: 14px;
                                border: 1px solid #DDDDDD;
                                border-radius: 20px;
                            }
                        }
                    }

                    .knowledge {
                        background-color: #0079FE;
                        height: 38px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0px 12px;

                        .knowledge_content {
                            font-size: 12px;
                            color: #fff;
                            line-height: 18px;
                            cursor: pointer;

                            .bi {
                                background-color: #fff;
                                padding: 2px;
                                font-size: 12px;
                                color: #0079FE;
                                margin-right: 5px;
                            }
                        }

                        .intelligent_tutoring {
                            font-size: 14px;
                            line-height: 22px;
                            color: #fff;
                            width: 80px;
                            cursor: pointer;

                            i {
                                color: #fff;
                            }
                        }
                    }
                }

                .next {
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    background-color: #eeeeee;
                    height: 56px;
                    width: 100%;

                    .next_btn {
                        cursor: pointer;
                        padding: 0 15px;
                        font-size: 14px;
                        line-height: 28px;
                        margin-right: 48px;
                        margin: 12px 48px 12px 0;
                        height: 28px;
                        background-color: #0079fe;
                        color: #fff;
                        border-radius: 4px;
                    }

                    .isdisabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }
        }

        .Subject_right {
            width: 192px;
            min-height: 610px;
            background-color: #333;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }


    }

    .challenge_content .Subject_left {
        width: 800px;
        height: 550px;
        background-color: #fff;
    }

    .progress {
        width: 760px;
        height: auto;
        margin: 30px 20px;
    }

    .progress .stem {
        display: block;
        width: 760px;
        height: auto;
        line-height: 25px;
        font-size: 15px;
        font-weight: bold;
    }

    .row {
        display: flex;
        flex-direction: row;
        width: 760px;
        height: 45px;
        margin: 10px 0;
        line-height: 20px;
        font-size: 14px;
        justify-content: space-around;
        color: #444;
    }

    .progress .title {
        display: block;
        width: 760px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        margin: 10px 0;
    }

    .row .letter {
        width: 30px;
        height: auto;
        margin: 15px 0;
    }

    .row .row_box {
        width: 50px;
        height: auto;
        display: flex;
        flex-direction: row;
    }

    .row .box2 {
        width: 20px;
        height: 20px;
        font-size: 15px;
        text-align: center;
        border-radius: 50%;
        margin: 15px 0;
        color: #f0f;
        background-color: #ccc;
    }

    .row .box3 {
        width: 700px;
        height: auto;
        margin: 15px 5px;
    }

    .box4 {
        width: 20px;
        height: 20px;
    }

    .box6 {
        position: relative;
        width: 50px;
        height: 40px;
        left: 620px;
    }

    .next_div {
        position: fixed;
        width: 800px;
        height: 40px;
        margin: 100px 0 10px 0;
    }

    .Popup {
        width: 80px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        color: #999;
        cursor: pointer;
        text-align: center;
        margin: 0 0 30px 0px;
        background-color: #333333;
        border-radius: 40px;
        border: 1px solid #fff;
    }

    .times {
        width: 174px;
        height: 65px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .times .title_name {
        width: 174px;
        height: 17px;
        line-height: 17px;
        font-size: 15px;
        color: #fff;
        text-align: center;
    }

    .times .title_time {
        height: 45px;
        display: flex;
        line-height: 45px;
        font-size: 32px;
        color: #fff;
        font-weight: 700;
    }

    .hides {
        width: 174px;
        height: 300px;
        display: flex;
        flex-direction: column;
        margin: 0 13px 2px 13px;
        .hide {
            width: 174px;
            height: 82px;

            .title {
                width: 174px;
                height: 22px;
                line-height: 22px;
                text-align: center;
                font-size: 15px;
                color: #d7d7d7;
            }

            .challenge_progress {
                height: 146px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 40px;

                .progress_div {
                    width: 130px;
                    height: 146px;
                    position: relative;

                    .img {
                        width: 130px;
                        height: 146px;
                    }

                    .center_img {
                        width: 86px;
                        height: 96px;
                        position: absolute;
                        left: 22px;
                        top: 24px;
						transition: all 0.5s ease;
                    }
					/* 6秒淡入动画（无背景，仅透明度变化） */
					.fade-in-simple {
						/* 初始状态：完全透明（隐藏） */
						opacity: 0;

						/* 3秒淡入动画（自动开始，结束后保持显示） */
						animation: simpleFadeIn 3s forwards ease-out;
					}

					/* 关键帧动画：仅透明度变化（0→1） */
					@keyframes simpleFadeIn {
						0% {
							opacity: 0; /* 完全透明 */
						}
						100% {
							opacity: 1; /* 完全显示 */
						}
					}
                    .progress_item1 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        left: 19px;
                        top: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item2 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        right: 19px;
                        top: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item3 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 60px;
                        right: -12px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item4 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        right: 19px;
                        bottom: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item5 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        left: 19px;
                        bottom: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item6 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 60px;
                        left: -12px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .finished_progress_item {
                        background-color: #0079FE;
                        color: #FFFFFF;
                    }

                    .unfinished_progress_item {
                        background-color: #FFFFFF;
                        color: #DDDDDD;
                    }

                    .current_progress_item {
                        background-color: #F6A31E;
                        color: #FFFFFF;
                    }

                    .right_progress_item {
                        background-color: #1DC11D;
                        color: #FFFFFF;
                    }

                    .error_progress_item {
                        background-color: #FF0000;
                        color: #FFFFFF;
                    }

                }

            }

            .line {
                text-align: center;
                color: #d7d7d7;
                border: 1px solid #d7d7d7;
                margin-top: 5px;
            }

            .questions {
                width: 174px;
                height: 60px;
                display: flex;
                flex-direction: row;
                margin-top: 20px;

                .correct {
                    width: 25px;
                    height: 60px;
                    margin-left: 34px;
                }

                .error {
                    width: 25px;
                    height: 60px;
                    margin-right: 25px;
                    margin-left: 60px;
                }

                .number {
                    height: 40px;
                    line-height: 40px;
                    font-size: 32px;
                    color: #f3f3f3;
                    font-weight: 700;
                    text-align: center;
                }

                .name {
                    width: 25px;
                    height: 14px;
                    text-align: center;
                    font-size: 12px;
                    color: #f3f3f3;
                    padding-top: 7px;
                }
            }

            .tips {
                width: 174px;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                margin: 25px 0 2px 0;
                color: #d7d7d7;
                text-align: center;
            }

            .imgs {
                width: 174px;
                height: 140px;
                margin-top: 10px;
                text-align: center;

                .img {
                    width: 140px;
                    height: 140px;
                }
            }

            .submit {
                width: 100px;
                height: 40px;
                line-height: 40px;
                margin: 25px 37px 25px 37px;
                border: 1px solid #fff;
                text-align: center;
                border-radius: 10px;
                font-size: 15px;
                color: #fff;
            }

            .again {
                margin-top: 50px;
                display: flex;
                justify-content: center;

                .btn {
                    height: 32px;
                    line-height: 32px;
                    background-color: #0079FE;
                    cursor: pointer;
                    border-radius: 3px;
                    width: 88px;
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                }
            }
        }

    }


    #dian {
        margin: 77px 37px 25px 37px;
        text-align: center;

        .finish_btn {
            padding: 12px 33px;
            font-size: 15px;
        }

    }

    .footer {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        position: fixed;
        bottom: 0;
        align-items: center;

        .bottom {
            width: 100%;
            height: 20px;
            margin: 0 auto;

            .railway {
                height: 50px;

                .img4 {
                    width: 100%;
                    height: 50px;
                }
            }
        }

        .top {
            width: 1400px;
            height: 50px;
            display: flex;
            flex-direction: row;

            .hill {
                height: 50px;
                display: flex;
                flex-direction: row;

                .img3 {
                    width: 200px;
                    height: 50px;
                }
            }

            .train {
                height: 40px;
                display: flex;
                padding: 0 20px;
                flex-direction: row;

                .train_num {
                    height: 40px;
                    margin-top: 10px;
                    display: flex;

                    .train_item {
                        position: relative;
                        cursor: pointer;

                        .span_num1, .span_num2, .span_num3 {
                            display: inline-block;
                            width: 20px;
                            height: 28px;
                            text-align: center;
                            line-height: 30px;
                            font-size: 16px;
                            position: absolute;
                        }

                        .span_num1 {
                            bottom: 5px;
                            right: 4px;
                        }

                        .span_num2 {
                            bottom: 5px;
                            right: 5px;
                        }

                        .span_num3 {
                            bottom: 5px;
                            left: 5px;
                        }

                        .isfinish {
                            /*background-color: #0079FE;*/
                            background-color: #0000C6;
                            color: #fff;
                        }

                        .nofinish {
                            background-color: skyblue;
                        }

                        .gou {
                            background-color: #1DC11D;
                            color: #fff;
                        }

                        .cha {
                            background-color: #FF0000;
                            color: #fff;
                        }
                    }

                    .img1 {
                        width: 100px;
                        height: 40px;
                    }

                    .img2 {
                        width: 90px;
                        height: 40px;
                        z-index: -1;
                    }
                }

                // @viewWidth: 100vw;
                .train_run {
                    position: relative;
                    animation: mymove 1.5s linear;
                    -webkit-animation: mymove 1.5s linear; /*Safari and Chrome*/
                }

                @keyframes mymove {
                    1% {
                        left: 0px;
                    }
                    100% {
                        left: 1500px;
                    }
                }
                @-webkit-keyframes mymove /*Safari and Chrome*/ {
                    1% {
                        left: 0px;
                    }
                    100% {
                        left: 1500px;
                    }
                }

                .diaplayNone {
                    opacity: 0;
                }

                .train_run2 {
                    opacity: 1;
                    position: relative;
                    animation: mymove2 1.5s linear;
                    -webkit-animation: mymove2 1.5s linear; /*Safari and Chrome*/
                }

                @keyframes mymove2 {
                    1% {
                        left: -1500px;
                    }
                    100% {
                        left: 0;
                    }
                }
                @-webkit-keyframes mymove2 /*Safari and Chrome*/ {
                    1% {
                        left: -1500px;
                    }
                    100% {
                        left: 0;
                    }
                }

                .img3 {
                    margin-left: 30px;
                    width: 200px;
                    height: 50px;
                }
            }
        }
    }

    /* 弹窗 */
    .EscModal {
        width: 432px;
        height: 192px;

        .Tips {
            z-index: -1;
            text-align: center;

            .top {
                height: 100px;

                .center {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 10px;

                    .img {
                        width: 60px;
                        height: 60px;
                    }
                }

                .p1 {
                    font-size: 16px;
                    padding-left: 37px;
                    text-align: left;
                    color: #333333;

                    .warning {
                        background-color: #FFBF00;
                        color: #ffffff;
                        display: inline-block;
                        width: 22px;
                        height: 22px;
                        text-align: center;
                        border-radius: 50%;
                        line-height: 22px;
                        margin-right: 7px;
                    }
                }

                .p2 {
                    padding-left: 70px;
                    text-align: left;
                    font-size: 14px;
                    color: #666666;
                }
            }

            .btn_div {
                margin-top: 20px;
                margin-bottom: 10px;

                .btn {
                    width: 88px;
                    height: 32px;
                    text-align: center;
                    cursor: pointer;
                    padding: 0;
                }
            }
        }
    }

    .video_operation {
        padding: 18px 0;

        .default-div {
            display: inline-block;
            border-radius: 8px;
            padding: 8px 16px;
            background-color: #F2F2F2;
            cursor: pointer;
            color: #9C9C9C;
            font-size: 14px;
            margin: 0 12px 10px 0;
        }
        .selected-div {
            display: inline-block;
            border-radius: 8px;
            padding: 8px 16px;
            background-color: #1677FF;
            cursor: pointer;
            color: #FFFFFF;
            font-size: 14px;
            margin: 0 12px 10px 0;

        }
    }
    .bottom_analysis {
        margin-top: 10px;
        line-height: 22px;
    }
</style>
<style lang="less" scoped>
	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 24px;
		border-bottom: 1px solid #ECECEC !important;

		.title {
			font-size: 18px;
			font-weight: bold;
			color: #333333 !important;
		}

		.subtitle {
			font-size: 14px;
			color: #666666 !important;
			opacity: 0.8;
		}
	}

	/* 深色模式适配 */
	@media (prefers-color-scheme: dark) {
		.modal-header {
			border-bottom-color: #333333 !important;
		}

		.title {
			color: #FFFFFF !important;
		}

		.subtitle {
			color: #CCCCCC !important;
		}
	}
	/* 加载动画容器 */
	.loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 50px 0;

		.loading-spinner {
			width: 40px;
			height: 40px;
			margin-bottom: 16px;
		}

		.loading-text {
			color: #666;
			font-size: 14px;
		}
	}

	/* 错误提示容器 */
	.error-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 50px 0;
		color: #ff4d4f;

		.error-icon {
			font-size: 40px;
			margin-bottom: 16px;
		}

		.error-text {
			margin-bottom: 20px;
			font-size: 14px;
		}
	}
	.diy-topic-title .content_html {
		width: auto!important;
		text-align: left;
	}
	/* 单选题选项优化 */
	.el-radio__label {
		font-size: 15px !important;
		color: #333333 !important;

		/* 悬停效果 */
		&:hover {
			color: #1890FF !important;
		}
	}

	/* 已选状态强化 */
	.el-radio__input.is-checked .el-radio__inner {
		border-color: #1890FF !important;
		background-color: #FFFFFF !important;
	}
	/* 弹窗滑入动画 */
	.v-enter-active,
	.v-leave-active {
		transition: all 0.3s ease-out;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
		transform: translateY(-20px);
	}
</style>
<style scoped>
	.analysis-content {
		/*max-height: 500px;*/
		/*overflow-y: auto;*/
		padding: 10px;
		line-height: 1.8;
		font-size: 15px;
		text-align: left !important; /* 强制文字靠左对齐 */
	}

	/* 列表样式修复（穿透 scoped，命中动态生成的 ol/ul/li） */
	::v-deep .analysis-content ol,
	::v-deep .analysis-content ul {
		padding-left: 24px;
		margin: 10px 0;
	}

	::v-deep .analysis-content li {
		margin: 8px 0;
	}

	/* 标题样式修复（穿透 scoped，命中动态生成的 h3 等） */
	::v-deep .analysis-content h1,
	::v-deep .analysis-content h2,
	::v-deep .analysis-content h3,
	::v-deep .analysis-content h4 {
		margin: 16px 0 8px;
		color: #6faddb;
		font-weight: 600;
	}

	::v-deep .analysis-content h3 {
		font-size: 18px;
	}

	/* 加载提示样式（组件内静态元素，无需穿透） */
	.loading-tip {
		color: #666;
		text-align: center;
		padding: 8px 0;
		font-size: 13px;
		margin-top: 10px;
	}

	.fixed-bottom {
		position: sticky;
		bottom: 0;
		background-color: #fff;
		border-top: 1px solid #f0f0f0;
		z-index: 10;
	}

	/* 错误提示样式（组件内静态元素，无需穿透） */
	.error-tip {
		color: #f56c6c;
		text-align: center;
		padding: 8px 0;
		font-size: 13px;
		margin-top: 10px;
	}

	/* 公式样式优化（穿透 scoped，命中 KaTeX 动态生成的元素） */
	::v-deep .analysis-content .katex {
		font-size: 1.1em !important;
	}

	::v-deep .analysis-content .katex-display {
		overflow-x: auto;
		white-space: nowrap;
		margin: 10px 0;
	}
</style>
<style>
	.coin {
		position: absolute;
		width: 40px;  /* 修改处9：60 → 40 */
		height: 40px; /* 修改处10：60 → 40 */
		border-radius: 50%;
		background: radial-gradient(circle at 30% 30%, #FFDF00, #D4AF37, #B8860B);
		box-shadow: 0 0 10px rgba(255, 215, 0, 0.8), /* 修改处11：阴影从15px改为10px */
		inset 2px 2px 6px rgba(255, 255, 255, 0.4), /* 修改处12：内阴影从8px改为6px */
		inset -2px -2px 4px rgba(0, 0, 0, 0.2); /* 修改处13：内阴影从5px改为4px */
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: bold;
		color: #8B5A2B;
		font-size: 18px; /* 修改处14：字体从24px改为18px */
		padding-bottom: 2px;
		z-index: 20;
		pointer-events: none;
		transition: opacity 0.5s ease, transform 0.5s ease;
		border: 1px solid rgba(255, 215, 0, 0.6);
	}

	/* 调整¥符号大小 */
	.coin::after {
		content: "¥";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 16px; /* 修改处15：从20px改为16px，适配40px金币 */
		font-weight: bold;
		color: #8b5a2b;
		text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
	}

	/* 调整金币纹理边框 */
	.coin::before {
		content: "";
		position: absolute;
		top: 10%;
		left: 10%;
		width: 80%;
		height: 80%;
		border-radius: 50%;
		border: 1px dashed rgba(255, 255, 255, 0.3);
		pointer-events: none;
	}

	/* 淡出类：透明度降低+轻微缩小 */
	.coin.fade-out {
		opacity: 0;
		transform: scale(0.8) translateY(15px); /* 修改处16：下落距离从20px改为15px */
		pointer-events: none;
	}
	/* 金币容器 - 全屏展示 */
	.coins-container {
		position: fixed;  /* 改为fixed定位，相对于视口 */
		top: 0;
		left: 0;
		width: 100vw;     /* 视口宽度100% */
		height: 100vh;    /* 视口高度100% */
		pointer-events: none;
		z-index: 9999;    /* 提高层级，确保在最上层 */
	}

	/* 收集的金币 */
	.coins-collected {
		position: absolute;
		bottom: 20px;
		left: 0;
		right: 0;
		display: none;
		/*display: flex;*/
		justify-content: center;
		gap: 10px;
		z-index: 15;
	}

	.collected-coin {
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: radial-gradient(circle at 30% 30%, #FFD700, #D4AF37);
		box-shadow: 0 0 4px rgba(255, 215, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		color: #B8860B;
	}
	/* 福袋按钮 - 全屏适配 */
	.fortune-bag-btn {
		position: fixed;
		bottom: -39px;     /* 距离底部50px */
		left: 50%;        /* 水平居中 */
		transform: translateX(-50%); /* 居中修正 */
		width: auto;
		height: auto;
		z-index: 10000;   /* 比金币更高 */
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.fortune-bag-btn img {
		width: 120px;
		height: 120px;
	}
</style>
